import {
  ISocialMediaPlatform,
  PhoneProvider,
  SocialMediaPlatform,
} from "../api";

export class SPAMComplaint implements ISPAMComplaint {
  anonymous?: boolean | undefined;
  governmentReferred?: boolean | undefined;
  businessReferred?: boolean | undefined;
  serviceProviderReferred?: boolean | undefined;
  writtenStatement?: boolean | undefined;
  noUnsubscribe?: boolean | undefined;
  title?: SPAMComplaintContactTitle;
  firstName?: string | undefined;
  lastName?: string | undefined;
  contactNumber?: string | undefined;
  postcode?: string | undefined;
  state?: SPAMComplaintContactState;
  email?: string | undefined;
  messages?: SPAMComplaintMessage[] | undefined;

  constructor(data?: ISPAMComplaint) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.anonymous = _data["anonymous"];
      this.governmentReferred = _data["governmentReferred"];
      this.businessReferred = _data["businessReferred"];
      this.serviceProviderReferred = _data["serviceProviderReferred"];
      this.writtenStatement = _data["writtenStatement"];
      this.noUnsubscribe = _data["noUnsubscribe"];
      this.title = _data["title"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.contactNumber = _data["contactNumber"];
      this.postcode = _data["postcode"];
      this.state = _data["state"];
      this.email = _data["email"];
      if (Array.isArray(_data["messages"])) {
        this.messages = [] as any;
        for (let item of _data["messages"])
          this.messages!.push(SPAMComplaintMessage.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SPAMComplaint {
    data = typeof data === "object" ? data : {};
    let result = new SPAMComplaint();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["anonymous"] = this.anonymous;
    data["governmentReferred"] = this.governmentReferred;
    data["businessReferred"] = this.businessReferred;
    data["serviceProviderReferred"] = this.serviceProviderReferred;
    data["writtenStatement"] = this.writtenStatement;
    data["noUnsubscribe"] = this.noUnsubscribe;
    data["title"] = this.title;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["contactNumber"] = this.contactNumber;
    data["postcode"] = this.postcode;
    data["state"] = this.state;
    data["email"] = this.email;
    if (Array.isArray(this.messages)) {
      data["messages"] = [];
      for (let item of this.messages) data["messages"].push(item.toJSON());
    }
    return data;
  }
}

export interface ISPAMComplaint {
  anonymous?: boolean | undefined;
  governmentReferred?: boolean | undefined;
  businessReferred?: boolean | undefined;
  serviceProviderReferred?: boolean | undefined;
  writtenStatement?: boolean | undefined;
  noUnsubscribe?: boolean | undefined;
  title?: SPAMComplaintContactTitle;
  firstName?: string | undefined;
  lastName?: string | undefined;
  contactNumber?: string | undefined;
  postcode?: string | undefined;
  state?: SPAMComplaintContactState;
  email?: string | undefined;
  messages?: ISPAMComplaintMessage[] | undefined;
}

export enum SPAMComplaintContactState {
  ACT = "ACT",
  NSW = "NSW",
  NT = "NT",
  QLD = "QLD",
  SA = "SA",
  TAS = "TAS",
  VIC = "VIC",
  WA = "WA",
}

export enum SPAMComplaintContactTitle {
  Dr = "Dr",
  Mr = "Mr",
  Mrs = "Mrs",
  Mr___Mrs = "Mr & Mrs",
  Miss = "Miss",
  Ms = "Ms",
  Prof = "Prof",
  Mx = "Mx",
}

export class SPAMComplaintMessage implements ISPAMComplaintMessage {
  uploadMessage?: boolean | undefined;
  pasteMessage?: string | undefined;
  fileName?: string | undefined;
  fileId?: string | undefined;
  allowMarketing?: boolean | undefined;
  allowMarketingInfo?: string | undefined;
  isCustomer?: boolean | undefined;
  isCustomerInfo?: string | undefined;
  attemptUnsubscribe?: boolean | undefined;
  attemptUnsubscribeInfo?: string | undefined;
  scam?: boolean | undefined;
  messageDate?: Date | undefined;
  messageType?: SPAMComplaintMessageType;
  businessName?: string | undefined;
  comments?: string | undefined;
  fromEmail?: string | undefined;
  toEmail?: string | undefined;
  subject?: string | undefined;
  fromPhone?: string | undefined;
  toPhone?: string | undefined;
  phoneProvider?: PhoneProvider;
  otherProvider?: string | undefined;
  platform?: SocialMediaPlatform;
  accountName?: string | undefined;
  anonymous?: boolean;
  file?: File;

  constructor(data?: ISPAMComplaintMessage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.anonymous = _data["anonymous"];
      this.uploadMessage = _data["uploadMessage"];
      this.pasteMessage = _data["pasteMessage"];
      this.fileName = _data["fileName"];
      this.fileId = _data["fileId"];
      this.file = _data["file"];
      this.allowMarketing = _data["allowMarketing"];
      this.allowMarketingInfo = _data["allowMarketingInfo"];
      this.isCustomer = _data["isCustomer"];
      this.isCustomerInfo = _data["isCustomerInfo"];
      this.attemptUnsubscribe = _data["attemptUnsubscribe"];
      this.attemptUnsubscribeInfo = _data["attemptUnsubscribeInfo"];
      this.scam = _data["scam"];
      this.messageDate = _data["messageDate"]
        ? new Date(_data["messageDate"].toString())
        : <any>undefined;
      this.messageType = _data["messageType"];
      this.businessName = _data["businessName"];
      this.comments = _data["comments"];
      this.fromEmail = _data["fromEmail"];
      this.toEmail = _data["toEmail"];
      this.subject = _data["subject"];
      this.fromPhone = _data["fromPhone"];
      this.toPhone = _data["toPhone"];
      this.phoneProvider = _data["phoneProvider"]
        ? PhoneProvider.fromJS(_data["phoneProvider"])
        : <any>undefined;
      this.otherProvider = _data["otherProvider"];
      this.platform = _data["platform"]
        ? SocialMediaPlatform.fromJS(_data["platform"])
        : <any>undefined;
      this.accountName = _data["accountName"];
    }
  }

  static fromJS(data: any): SPAMComplaintMessage {
    data = typeof data === "object" ? data : {};
    let result = new SPAMComplaintMessage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["anonymous"] = this.anonymous;
    data["uploadMessage"] = this.uploadMessage;
    data["pasteMessage"] = this.pasteMessage;
    data["fileName"] = this.fileName;
    data["fileId"] = this.fileId;
    data["file"] = this.file;
    data["allowMarketing"] = this.allowMarketing;
    data["allowMarketingInfo"] = this.allowMarketingInfo;
    data["isCustomer"] = this.isCustomer;
    data["isCustomerInfo"] = this.isCustomerInfo;
    data["attemptUnsubscribe"] = this.attemptUnsubscribe;
    data["attemptUnsubscribeInfo"] = this.attemptUnsubscribeInfo;
    data["scam"] = this.scam;
    data["messageDate"] = this.messageDate
      ? this.messageDate.toISOString()
      : <any>undefined;
    data["messageType"] = this.messageType;
    data["businessName"] = this.businessName;
    data["comments"] = this.comments;
    data["fromEmail"] = this.fromEmail;
    data["toEmail"] = this.toEmail;
    data["subject"] = this.subject;
    data["fromPhone"] = this.fromPhone;
    data["toPhone"] = this.toPhone;
    data["phoneProvider"] = this.phoneProvider
      ? this.phoneProvider.toJSON()
      : <any>undefined;
    data["otherProvider"] = this.otherProvider;
    data["platform"] = this.platform ? this.platform.toJSON() : <any>undefined;
    data["accountName"] = this.accountName;
    return data;
  }
}

export interface ISPAMComplaintMessage {
  uploadMessage?: boolean | undefined;
  pasteMessage?: string | undefined;
  fileName?: string | undefined;
  fileId?: string | undefined;
  allowMarketing?: boolean | undefined;
  allowMarketingInfo?: string | undefined;
  isCustomer?: boolean | undefined;
  isCustomerInfo?: string | undefined;
  attemptUnsubscribe?: boolean | undefined;
  attemptUnsubscribeInfo?: string | undefined;
  scam?: boolean | undefined;
  messageDate?: Date | undefined;
  messageType?: SPAMComplaintMessageType;
  businessName?: string | undefined;
  comments?: string | undefined;
  fromEmail?: string | undefined;
  toEmail?: string | undefined;
  subject?: string | undefined;
  fromPhone?: string | undefined;
  toPhone?: string | undefined;
  phoneProvider?: PhoneProvider;
  otherProvider?: string | undefined;
  platform?: ISocialMediaPlatform;
  accountName?: string | undefined;
  anonymous?: boolean;
  file?: File;
}

export enum SPAMComplaintMessageType {
  Email = "Email",
  SMS_MMS = "SMS/MMS",
  Instant_message = "Instant message",
  Phone_call = "Phone call",
}

export interface ProgressStageProps {
  submission: ISPAMComplaint;
  onChange?: (submission: ISPAMComplaint) => void;
  onPrevious: () => void;
  onNext: (submission?: ISPAMComplaint) => void;
}
